// extracted by mini-css-extract-plugin
module.exports = {"cardDiv":"share_cardDiv__2qF0K","center":"share_center__1p7Qu","modalContent":"share_modalContent__3eFTM","modalBackdrop":"share_modalBackdrop__1TqFU"};